// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jq-0";
export var buttonContainer = "_jq-3";
export var cancelButton = "_jq-4";
export var headerSection = "_jq-6";
export var headerTitle = "_jq-9";
export var messageSideLeft = "_jq-1";
export var messageSideRight = "_jq-2";
export var orderNumberContainer = "_jq-7";
export var orderNumberLabel = "_jq-8";
export var submitButton = "_jq-5";